import React from 'react';
import { LucideIcon } from 'lucide-react';

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  action?: React.ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ icon: Icon, title, description, action }) => (
  <div className="text-center py-12 px-4">
    <div className="mx-auto mb-3 w-12 h-12 rounded-full bg-gray-50 flex items-center justify-center">
      <Icon className="text-gray-300" size={24} />
    </div>
    <p className="text-gray-700 font-medium">{title}</p>
    {description && <p className="text-sm text-gray-400 mt-1">{description}</p>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);
